var VideoPopper = (function () {
    function VideoPopper(options) { 
        this.options = options;
        this.classContainer = $("."+options.classContainer);         	
    }
/*
     VideoPopper.prototype.func_close = function (index) {
        $('#modal' + index).remove();
        $(".modal-backdrop").remove();
        $('body').removeClass('modal-open');
        $('body').removeAttr('style');
        $('nav').removeAttr('style');        
    };
*/
  
     VideoPopper.prototype.getUrlVars = function (url) {
        var vars = [], hash;
        var hashes = url.href.slice(url.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    };

    VideoPopper.prototype.AllfilmVideoPopper = function () {
       
      this.classContainer.each(function (i, link) { 
            var permalink = $(this);
           
            $(permalink).unbind("click");
            $(permalink).click(function (event) {               	 
				if (permalink.attr('id')) {
					params = permalink.attr('id');
				} else {
					params = permalink.attr('data-content');
					//params = getUrlVars(link);                    
				}	
             
              
                permalink.after(
					$body_overlay = $('<div id="modal' + i + '" class="modal fade inv-modal-video" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" tabindex="-1">').append(
						$wrapper = $('<div class="modal-dialog modal-lg modal-dialog-centered" role="document">').append(
                            $content = $('<div class="modal-content">').append(
                                $header = $('<div class="modal-header">').append(
                                    $closeButton = $('<button type="button" class="close" data-dismiss="modal">').append('<span class="align-middle">&times;</span><span class="align-middle fs-s pl-1 font-weight-normal">Close</span>')
                                ),
                                $body = $('<div class="modal-body mb-0 p-0">').append(
                                    $wapBody = $(' <div class="embed-responsive embed-responsive-16by9 z-depth-1-half">').append(
                                        $player = $('<video class="video-fluid z-depth-1" autoplay controls>').append('<source src="' + params + '" type="video/mp4" />')
                                    ))                                 
                               )
					    ),
                        "<script type='text/javascript'>$('#modal" + i + "').on('hidden.bs.modal', function (e) { return func_close(" + i + ")});"
                    )
				);
               

             
                $('#modal' + i ).modal("show");
				               
                return false;
            });

        });
    };

  
   return VideoPopper;

}());


func_close = function (index) {
  $('body').click();
  $('#modal' + index).remove();  
  $(".modal-backdrop").remove();
  
  //$('body').removeClass('modal-open');
 // $('body').removeAttr('style');
 // $('nav').removeAttr('style');    
  
  return false;
};